import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import React from "react"

class NextStep extends React.Component {
  static displayName = "NextStep"

  render() {
    const step = this.props.nextStep
    if (step.item_type !== "G") {
      return (
        <Button
          ariaLabelledBy={"next-button"}
          brand
          to={step.url}
          styleType="primary"
          size="large"
        >
          <Text
            id={`next-button`}
            lines={1}
            style={{ color: "inherit", fontWeight: "inherit" }}
          >{`${this.props.t("step.next")} `}</Text>
          <Pathicon icon="chevron-right" />
        </Button>
      )
    } else {
      return (
        <div>
          <p>{this.props.t("step.up_next")}</p>
          <Button
            ariaLabelledBy={`up-next-button`}
            brand
            to={step.url}
            styleType="primary"
            size="large"
          >
            <Text
              id={`up-next-button`}
              lines={1}
              style={{ color: "inherit", fontWeight: "inherit" }}
            >
              {step.name}
            </Text>
          </Button>
        </div>
      )
    }
  }
}

export default withTranslate(NextStep)
